/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as privateRouteRouteImport } from './routes/(private)/route'
import { Route as authRouteRouteImport } from './routes/(auth)/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as privateDashboardRouteImport } from './routes/(private)/dashboard'
import { Route as authLoginRouteImport } from './routes/(auth)/login'
import { Route as privateSelecionarEstabelecimentoIndexRouteImport } from './routes/(private)/selecionar-estabelecimento/index'
import { Route as privateFilaIndexRouteImport } from './routes/(private)/fila/index'

const privateRouteRoute = privateRouteRouteImport.update({
  id: '/(private)',
  getParentRoute: () => rootRouteImport,
} as any)
const authRouteRoute = authRouteRouteImport.update({
  id: '/(auth)',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const privateDashboardRoute = privateDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => privateRouteRoute,
} as any)
const authLoginRoute = authLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => authRouteRoute,
} as any)
const privateSelecionarEstabelecimentoIndexRoute =
  privateSelecionarEstabelecimentoIndexRouteImport.update({
    id: '/selecionar-estabelecimento/',
    path: '/selecionar-estabelecimento/',
    getParentRoute: () => privateRouteRoute,
  } as any)
const privateFilaIndexRoute = privateFilaIndexRouteImport.update({
  id: '/fila/',
  path: '/fila/',
  getParentRoute: () => privateRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof authLoginRoute
  '/dashboard': typeof privateDashboardRoute
  '/fila': typeof privateFilaIndexRoute
  '/selecionar-estabelecimento': typeof privateSelecionarEstabelecimentoIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof authLoginRoute
  '/dashboard': typeof privateDashboardRoute
  '/fila': typeof privateFilaIndexRoute
  '/selecionar-estabelecimento': typeof privateSelecionarEstabelecimentoIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/(auth)': typeof authRouteRouteWithChildren
  '/(private)': typeof privateRouteRouteWithChildren
  '/(auth)/login': typeof authLoginRoute
  '/(private)/dashboard': typeof privateDashboardRoute
  '/(private)/fila/': typeof privateFilaIndexRoute
  '/(private)/selecionar-estabelecimento/': typeof privateSelecionarEstabelecimentoIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/dashboard'
    | '/fila'
    | '/selecionar-estabelecimento'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/login' | '/dashboard' | '/fila' | '/selecionar-estabelecimento'
  id:
    | '__root__'
    | '/'
    | '/(auth)'
    | '/(private)'
    | '/(auth)/login'
    | '/(private)/dashboard'
    | '/(private)/fila/'
    | '/(private)/selecionar-estabelecimento/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  authRouteRoute: typeof authRouteRouteWithChildren
  privateRouteRoute: typeof privateRouteRouteWithChildren
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/(private)': {
      id: '/(private)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof privateRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(auth)': {
      id: '/(auth)'
      path: ''
      fullPath: ''
      preLoaderRoute: typeof authRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/(private)/dashboard': {
      id: '/(private)/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof privateDashboardRouteImport
      parentRoute: typeof privateRouteRoute
    }
    '/(auth)/login': {
      id: '/(auth)/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof authLoginRouteImport
      parentRoute: typeof authRouteRoute
    }
    '/(private)/selecionar-estabelecimento/': {
      id: '/(private)/selecionar-estabelecimento/'
      path: '/selecionar-estabelecimento'
      fullPath: '/selecionar-estabelecimento'
      preLoaderRoute: typeof privateSelecionarEstabelecimentoIndexRouteImport
      parentRoute: typeof privateRouteRoute
    }
    '/(private)/fila/': {
      id: '/(private)/fila/'
      path: '/fila'
      fullPath: '/fila'
      preLoaderRoute: typeof privateFilaIndexRouteImport
      parentRoute: typeof privateRouteRoute
    }
  }
}

interface authRouteRouteChildren {
  authLoginRoute: typeof authLoginRoute
}

const authRouteRouteChildren: authRouteRouteChildren = {
  authLoginRoute: authLoginRoute,
}

const authRouteRouteWithChildren = authRouteRoute._addFileChildren(
  authRouteRouteChildren,
)

interface privateRouteRouteChildren {
  privateDashboardRoute: typeof privateDashboardRoute
  privateFilaIndexRoute: typeof privateFilaIndexRoute
  privateSelecionarEstabelecimentoIndexRoute: typeof privateSelecionarEstabelecimentoIndexRoute
}

const privateRouteRouteChildren: privateRouteRouteChildren = {
  privateDashboardRoute: privateDashboardRoute,
  privateFilaIndexRoute: privateFilaIndexRoute,
  privateSelecionarEstabelecimentoIndexRoute:
    privateSelecionarEstabelecimentoIndexRoute,
}

const privateRouteRouteWithChildren = privateRouteRoute._addFileChildren(
  privateRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  authRouteRoute: authRouteRouteWithChildren,
  privateRouteRoute: privateRouteRouteWithChildren,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
